import React from 'react';
import { IExtension } from '../Interfaces/IExtension';
import { Box, Button, Typography, useTheme } from '@mui/material';

interface IProps {
  extension: IExtension;
}

export const ExtensionCard: React.FC<IProps> = ({ extension }) => {
  const theme = useTheme();

  const openLink = () => {
    window.open(String(extension.hubspot_link), '_blank');
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.grey[100],
        p: 3,
        borderRadius: 4,
        border: `1px solid ${theme.palette.grey[200]}`,
        mb: 2,
        width: 400,
      }}
    >
      <Typography variant='h5' component='h3'>
        {extension.extension_name}
        {extension.isHighlighted && ' ⭐'}
      </Typography>
      <Typography variant='h6' sx={{ float: 'right' }}>
        {extension.selling_price.toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR',
        })}{' '}
        €
      </Typography>
      <Box sx={{ mt: 5 }} />
      <div dangerouslySetInnerHTML={{ __html: extension.descriptionHtml }} />
      {extension.dino_link !== null && (
        <a target='blank_' href={extension.dino_link}>
          Mehr lesen
        </a>
      )}
      {extension.hubspot_link !== null && (
        <Button variant='contained' onClick={openLink} sx={{ float: 'right' }}>
          {' '}
          Aktivieren!
        </Button>
      )}
    </Box>
  );
};
